import React from 'react'
import styled, {css, useTheme} from 'styled-components'
import {Box, Button, FocusTrap, Text} from '@miro-site/core'

const Controls = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${FocusTrap} {
    padding: 0;
  }
`

interface IndicatorsProps {
  $isInactiveFrom?: number
}
const Indicators = styled.div<IndicatorsProps>`
  display: flex;
  justify-content: space-between;

  > * {
    border-bottom: 1px solid var(--wcds-onboarding-indicator-active-color);
    flex-grow: 1;
    border-radius: 100px;
    &:not(:first-child) {
      margin-left: 4px;
    }
    ${({$isInactiveFrom, theme}) =>
      $isInactiveFrom &&
      css`
        &:nth-child(n + ${$isInactiveFrom}) {
          border-bottom-color: var(--wcds-onboarding-indicator-inactive-color);
        }
      `}
  }
`

interface Props {
  onBack?: () => void
  onSkip: () => void
  numberOfAllQuestions: number
  numberOfCurrentQuestion: number
  labels: Record<string, string>
}

const Header: React.FC<Props> = ({
  onBack,
  onSkip,
  numberOfAllQuestions,
  numberOfCurrentQuestion,
  labels,
}) => {
  const theme = useTheme()
  return (
    <div>
      <Controls $mb={10}>
        {onBack ? (
          <Button
            $buttonType="transparentWhite"
            $size="small"
            $styles={{
              padding: theme.spaces.sm,
              borderColor: 'var(--wcds-onboarding-button-border-color)',
              '&:hover': {
                borderColor: 'var(--wcds-onboarding-button-border-color)',
                color: 'var(--wcds-colors-text-btn-primary-hover)',
              },
            }}
            onClick={onBack}
          >
            <Text
              $styles={{
                color: 'inherit',
              }}
              $variant="p2"
            >
              {labels.headerBack}
            </Text>
          </Button>
        ) : (
          <div></div>
        )}
        <Text $styles={{color: 'var(--wcds-onboarding-inactive-text-color)'}} $variant="p2">
          {labels.headerQuestion} {numberOfCurrentQuestion}/{numberOfAllQuestions}
        </Text>
        <Button
          $buttonType="transparentWhite"
          $size="small"
          $styles={{
            padding: theme.spaces.sm,
            borderColor: 'var(--wcds-onboarding-button-border-color)',
            color: 'var(--wcds-onboarding-inactive-text-color)',
            '&:hover': {
              borderColor: 'var(--wcds-onboarding-button-border-color)',
              color: 'var(--wcds-colors-text-btn-primary-hover)',
            },
          }}
          onClick={onSkip}
        >
          <Text
            $styles={{
              color: 'inherit',
            }}
            $variant="p2"
          >
            {labels.headerSkip}
          </Text>
        </Button>
      </Controls>
      <Indicators $isInactiveFrom={numberOfCurrentQuestion + 1}>
        {[...new Array(numberOfAllQuestions)].map((val, index) => (
          <div key={index}></div>
        ))}
      </Indicators>
    </div>
  )
}

export default Header
